import { render, staticRenderFns } from "./WinnerRow.vue?vue&type=template&id=8ebfd26e&lang=pug"
import script from "./WinnerRow.vue?vue&type=script&lang=js"
export * from "./WinnerRow.vue?vue&type=script&lang=js"
import style0 from "./WinnerRow.vue?vue&type=style&index=0&id=8ebfd26e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports